import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';

import { DateFormat } from '../../../constants/data';
import { selectDate } from '../../../store/slices/sensors';
import { IsSeasonDateHasLocation } from '../Gantt.lib.jsx';
import { MapLat, MapLng } from '../../../constants/keys';
import { PathnamesMap } from '../../../constants/ui';
import { goToTimeline } from '../../../utils/common';
import { selectField } from '../../../store/slices/fields';

const useOnClickLocation = ({ locations, notes, openNotesPanel }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (itemId, e, time) => {
    if (itemId.startsWith('edit')) return;

    let date = dayjs(time).format(DateFormat);
    if (dayjs(time) > dayjs()) {
      date = dayjs().format(DateFormat);
    }

    if (itemId.startsWith('location')) {
      // go to the timeline page
      dispatch(selectDate());
      const id = itemId.substring(8) // remove 'location'
      goToTimeline({ id, date, navigate });
    } else if (itemId.startsWith('note-')) {
      // open notes panel
      const extra = itemId.startsWith('note-month') ? 10 : 5;
      const id = itemId.substring(extra, 36 + extra);
      if (locations && locations.length && notes && notes.length) {
        const notesLocation = notes.filter((obj) => obj.location_id === id);
        const location = locations.filter((l) => l.id === id);
        if (location && location.length) {
          openNotesPanel({ notesLocation, location: location[0], date });
        }
      }
    } else {
      // click on season - go to the map page
      const currentLocations = locations.filter((location) => location.field_season_id === itemId);
      if (currentLocations.length > 0) {
        // have a location
        let dateIsGood = IsSeasonDateHasLocation(currentLocations, date);
        localStorage.removeItem(MapLat);
        localStorage.removeItem(MapLng);
        dispatch(selectDate(dateIsGood ? date : dayjs(currentLocations[0].sensor.synced_at).format(DateFormat)));
        dispatch(selectField({ id: itemId}));
        navigate({ pathname: `/${PathnamesMap.map}`});
      } else {
        // have no location
        // dispatch(selectSeason(itemId));
        // navigate({ pathname: `/${PathnamesMap.fields}`});
      }
    }
  };
};

export default useOnClickLocation;
